/**
 * Filters a list of items using case-insensitive substring matching against item properties
 * and formatted option labels from getOptionLabel.
 *
 * @param {Array} items - The list of items to filter.
 * @param {string} query - The search query string.
 * @param {string[]} [columns] - Optional array of property keys to check. If omitted, checks all keys on each item.
 * @param {Function} [getOptionLabel] - Optional function (key, value, extraOptions) => string to get formatted display text.
 * @param {any} [extraOptions] - Extra options to pass to getOptionLabel (e.g., allMemberTypeNames).
 * @returns {Array} - Filtered items.
 */
export function filterItems(items, query, columns, getOptionLabel, extraOptions) {
  if (!Array.isArray(items)) return [];
  if (!query || typeof query !== 'string' || !query.trim()) {
    return items;
  }

  const normalizedQuery = query.trim().toLowerCase();

  return items.filter(item => {
    if (!item || typeof item !== 'object') return false;

    const keysToCheck = Array.isArray(columns) && columns.length > 0
      ? columns
      : Object.keys(item);

    for (const key of keysToCheck) {
      const rawVal = item[key];
      if (rawVal !== null && rawVal !== undefined) {
        const rawStr = String(rawVal).toLowerCase();
        if (rawStr.includes(normalizedQuery)) {
          return true;
        }
      }

      if (typeof getOptionLabel === 'function') {
        try {
          const label = getOptionLabel(key, rawVal, extraOptions);
          if (label !== null && label !== undefined) {
            const labelStr = String(label).toLowerCase();
            if (labelStr.includes(normalizedQuery)) {
              return true;
            }
          }
        } catch (e) {
          // Ignore formatting errors during search matching
        }
      }
    }

    return false;
  });
}

export default filterItems;
